import styled from "@emotion/styled/macro";
import trashIcon from "../assets/images/trash-icon.svg";

const RemoveIcon = styled.button`
  padding: 25px;
  border: none;
  background: url(${trashIcon}) no-repeat center;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
  }
`;

export { RemoveIcon };
